<template>
  <div class="container">
    <el-row>
      <el-col :offset="12" :span="10" style="text-align:right" >
        <el-button v-if="showDownload" type="primary" size="small" @click="download" style="margin: 10px">下载报表</el-button>
      </el-col>
    </el-row>
    <div ref="vizContainer"></div>
  </div>
</template>
<script>
  export default {
    name: "TableauView",
    props: {
      url: String
    },
    data () {
      return {
        host: 'https://tableau.wuren.com',
        vizOptions: {
          hideTabs: true,
          width: "95%",
          height: "2400px",
          device: 'desktop',
          hideToolbar: true
        },
        viz: undefined,
        showDownload: false,
      }
    },
    mounted() {
    },
    created() {

      this.initViz();

    },
    methods: {

      async getTbTicket() {

        let rst = await this.$http.get('/ams/admin/tb/ticket');
        let ticket = rst.data.ticket;

        return ticket;

      },

      async initViz() {

        this.showDownload = false;

        let url = this.url;
        url = url.replace(this.host, '');

        let ticket = await this.getTbTicket();

        let turl = `${this.host}/trusted/${ticket}/${url}`;

        let containerDiv = this.$refs['vizContainer'];

        let viz = new tableau.Viz(containerDiv, turl, this.vizOptions);
        this.viz = viz;

        this.showDownload = true;

      },

      download() {
        this.viz.showDownloadDialog();
      }

    }
  }
</script>
<style lang='less' scoped>
.container {
  padding: 20px;
}
</style>
